import { Interfaces, Models, AppConstants } from "@/core/Export";
import "whatwg-fetch";

class ApiService {
  private _token: string = null;
  private _accessToken: string = null;
  private _role: string = null;
  private _authority: string = null;

  constructor() {}

  public sendOnPropertyChanged(parameters: Models.onPropertyChangeOptions) {
    return this.post(
      "Forms" + "/" + parameters.entityName + "/" + parameters.id + "/onchange",
      parameters
    );
  }

  getFile(path: string, params?: any) {
    return fetch(AppConstants.Http.BaseUrl + "/" + path, {
      method: AppConstants.HttpMethods.Post,
      headers: this.getHeaders(),
      body: JSON.stringify(params)
    })
      .then(response => {
        if (response.ok) {
          return response.blob();
        } else {
          return Promise.reject(response);
        }
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }

  uploadFiles(requestId: string, formData: FormData) {
    return fetch(
      AppConstants.Http.BaseUrl + "/" + "File/UploadFiles/" + requestId,
      {
        method: AppConstants.HttpMethods.Post,
        headers: this.getAuthHeader(),
        body: formData
      }
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          return Promise.reject(response);
        }
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }

  saveForm(entityName: string, id: string, formData: any) {
    return this.post("Forms" + "/" + entityName + "/" + id, formData);
  }

  getForm(entityName: string, id: string) {
    return this.get("Forms" + "/" + entityName + "/" + id);
  }

  getForm_Post(entityName: string, id: string, params?: any) {
    if (!params) params = {};
    return this.post("Forms/get" + "/" + entityName + "/" + id, params);
  }

  getEntity(entityName: string, id: string) {
    return this.get("Entity" + "/" + entityName + "/" + id);
  }

  getEntityList(entityName: string, params?: any) {
    return this.get("Entity" + "/" + entityName, params);
  }

  post(path: string, params?: any) {
    return this.sendRequest(path, AppConstants.HttpMethods.Post, params);
  }

  get(path: string, params?: any) {
    return this.sendRequest(path, AppConstants.HttpMethods.Get, params);
  }

  getSystemData(path: string, authority) {
    this._authority = authority;
    return this.sendRequest(path, AppConstants.HttpMethods.Get);
  }

  sendRequest(path: string, method: string, params?: any): Promise<any> {
    return fetch(AppConstants.Http.BaseUrl + "/" + path, {
      method: method,
      headers: this.getHeaders(),
      body: JSON.stringify(params)
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          return Promise.reject(response);
        }
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }

  private getHeaders() {
    return {
      "X-Requested-With": "Fetch",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json",
      role: this._role,
      accesstoken: this._accessToken,
      authorization: "Bearer " + this._token,
      authority:this._authority
    };
  }

  private getAuthHeader() {
    return {
      accesstoken: this._accessToken,
      authorization: "Bearer " + this._token,
      authority:this._authority
    };
  }

  setHeaders(jwtToken: string, accessToken: string, role: string, authority:string) {
    if (jwtToken) {
      this._token = jwtToken;
    }

    if (accessToken) {
      this._accessToken = accessToken;
    }

    if (role) {
      this._role = role;
    }

    if (authority) {
      this._authority = authority;
    }
  }
}

export const apiService = new ApiService();
